import React, {Component} from 'react'

/**
 * Created by slf on 2017/8/4.
 */
import {language, pageOption} from 'UTIL/common'
import bumpService from 'SERVICES/purifier/bump/bumpService'
import Tip from 'CONFIG/component/tip'
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
import Modal from "../../../component/modal";
export default class searchBindDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            pageSize: 10,
            page: 1,
            total: 0,
            unBindList:{},
            id:''
        }
    }

    componentDidMount() {
        if(this.props.params.id != null || this.props.params.id != ''){
            $("#search").val(this.props.params.id)
            this.setState({
                id:this.props.params.id
            },()=>{
                $("#search").val(this.state.id);
                this.onPageChange(this.state.page, this.state.pageSize);
            })
        }else{
            this.onPageChange(this.state.page, this.state.pageSize);
        }
        
    }
    onPageChange(page, sizePerPage, e){
        let data = {
            "page": page,
            "pageSize": sizePerPage,
            "search": $.trim($("#search").val()),
        }
        data = JSON.stringify(data);
        bumpService.searchBindList({data}).then(body=>{
            console.log(body)
            this.setState({
                list:body.data.records,
                pageSize: sizePerPage,
                page: page,
                total: body.data.total,
            })
        })
    }
    search(){
        this.onPageChange(1, 10);
    }
    reset(){
        $("#search").val('');
        this.onPageChange(1,10)
    }
    handle(cell,row){
        return <div>
            <a  className="btn btn-danger btn-sm" data-target="#unBindModal" data-toggle="modal"
                onClick={this.unBindList.bind(this,row)}>{language()['unBind']}</a>
        </div>
    }
    unBindList(row){
        this.setState({
            unBindList : row,
        })
    }
    unBindSure(){
        let row = this.state.unBindList;
        let data = {
            userId : row.userId,
            deviceId : row.deviceNo,
            factoryId : row.factoryId,
            productId: row.productId
        };
        data = JSON.stringify(data);
        
        bumpService.dvcBaseUnbindDvc({data}).then(body=>{
            console.log(body)
            if (body.code == 8001) {
                this.onPageChange(1,10)
                $("#success_msg").text(body.msg);
                $("#success_tip").removeClass("hidden");
                $("#success_tip").focus();
                setTimeout(function () {
                    $("#success_tip").addClass("hidden");
                }, 3000);
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                $("#error_tip").focus();
                setTimeout(function () {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
        })
    }
    render() {
        let options = pageOption(this.state.page, this.state.pageSize);
        options['onPageChange'] = this.onPageChange.bind(this);
        const _this = this;
        options['paginationShowsTotal'] =function () {
            return <span style={{paddingRight:'10px'}}>
                共 <span className="bg-blue" style={{fontSize:'20px',padding:'2px 4px',borderRadius:'5px'}}>{_this.state.total}</span> 条数据
            </span>
        };
        return <div>
            <section className="content-header ">
                <h1>{language()['AirPurifierManagement']}
                    <small>{language()['SearchBindList']}</small>
                </h1>
            </section>
            <section className="content">
                <div className="box box-primary color-palette-box">
                    <div className="box-header with-border">
                        <i className="fa fa-list"></i>
                        <h3 className="box-title">{language()['SearchBindList']}</h3>
                    </div>
                    <div className="box-body">
                        <Tip ids=""/>
                        <div className="title-box">
                            <div className="clearfix">
                                <LongSearchInput id="search" name={language()['deviceNo']+"/"+
                                language()['userId']+"/"+language()['loginName']+"/"+language()['dvcModel']}/>
                                <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>
                                &nbsp;&nbsp;
                                <button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                    {language()['resetting']}
                                </button>
                            </div>
                        </div>
                        <BootstrapTable data={this.state.list} remote={true} fetchInfo={{dataTotalSize: this.state.total}} striped
                                        hover pagination={true} options={options} ref='table'>
                            <TableHeaderColumn isKey dataField='id'hidden="true" >id </TableHeaderColumn>
                            <TableHeaderColumn dataField='loginName' width="200">{language()['loginName']}</TableHeaderColumn>
                            <TableHeaderColumn dataField='userId' width="200">{language()['userId']}</TableHeaderColumn>
                            <TableHeaderColumn dataField='deviceNo' width="200">{language()['deviceNo']}</TableHeaderColumn>
                            <TableHeaderColumn dataField='factoryId' width="200">{language()['openID']}</TableHeaderColumn>
                            <TableHeaderColumn dataField='productId' width="200">{language()['productID']}</TableHeaderColumn>
                            <TableHeaderColumn dataField="dvcModel" width="120">{language()['dvcModel']}</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={this.handle.bind(this)} width="120">{language()['operation']}</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </section>
            <Modal modal={{"id":'unBindModal',"title":'unBindDevice',"text":"ReayToUnBindDevice"}}  modalSure= {this.unBindSure.bind(this)}/>
        </div>
    }
}


// WEBPACK FOOTER //
// ./modules/bump/back/dvcBase/searchBindDevice.js